import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';

import moment from 'moment'
import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi.ts_';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as rent_contracts_check_api from '../Api/rent_contracts_check_api';
// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';
// import * as Kyousai from '../../Kyousai/Saga/Kyousai';
///types


//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface RentContractMoniesState {
    // rent_contract_monies:any;
    rent_contracts_check_list: any;
    search_form: any;
    search_contract_date_start: any;
    search_contract_date_end: any;
    search_tatemono_name: any;
    parking_check_loading: number;
    net_check_loading: number;

    energization_check_loading: number;

    electronics_check_loading: number;
    wifi_check_loading: number;
    autolock_check_loading: number;
    search_loading: boolean;
    owner_tel_check_loading: number;
    kyoukyuu_titen_list: any;
    rent_contract_logs: any;
}
const initialState: RentContractMoniesState = {

    // rent_contract_monies: [],
    rent_contracts_check_list: [],
    search_form: {
        search_name: null,
        search_contract_date_start: null,
        search_contract_date_end: null,
        search_tatemono_name: null,
        search_completed: false,
    },
    search_contract_date_start: null,
    search_contract_date_end: null,
    search_tatemono_name: "",

    parking_check_loading: 0,
    net_check_loading: 0,

    energization_check_loading: 0,

    electronics_check_loading: 0,
    wifi_check_loading: 0,
    autolock_check_loading: 0,
    search_loading: false,
    owner_tel_check_loading: 0,
    kyoukyuu_titen_list: [],
    rent_contract_logs: []
    // users: [],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();

// export const get_rent_contract_monies = actionCreator<{rent_contract_id:number}>('GET_RENT_CONTRACT_MONIES');
// export const get_rent_contract_monies_success = actionCreator("GET_RENT_CONTRACT_MONIES_SUCCESS");
// export const get_rent_contract_monies_failure = actionCreator("GET_RENT_CONTRACT_MONIES_FAILURE");

// export const get_rent_contract_accounting = actionCreator("GET_RENT_CONTRACT_ACCOUNTING");


export const get_rent_contracts_check_list = actionCreator<any>('GET_RENT_CONTRACTS_CHECK_LIST');
export const change_rent_contracts_check_list = actionCreator<any>("CHANGE_RENT_CONTRACTS_CHECK_LIST");

export const parking_checked = actionCreator("PARKING_CHECKED");
export const change_parking_check_loading = actionCreator<number>("CHANGE_PARKING_CHECK_LOADING");

export const net_checked = actionCreator("NET_CHECKED");
export const change_net_check_loading = actionCreator<number>("CHANGE_NET_CHECK_LOADING");

export const energization_checked = actionCreator("ENERGIZATION_CHECKED");
export const change_energization_check_loading = actionCreator<number>("CHANGE_ENERGIZATION_CHECK_LOADING");

export const electronics_checked = actionCreator("ELECTRONICS_CHECKED");
export const change_electronics_check_loading = actionCreator<number>("CHANGE_ELECTRONICS_CHECK_LOADING");

export const wifi_checked = actionCreator("WIFI_CHECKED");
export const change_wifi_check_loading = actionCreator<number>("CHANGE_WIFI_CHECK_LOADING");

export const autolock_checked = actionCreator("AUTOLOCK_CHECKED");
export const change_autolock_check_loading = actionCreator<number>("CHANGE_AUTOLOCK_CHECK_LOADING");

export const completed_checked = actionCreator("COMPLETED_CHECKED");


export const all_selected = actionCreator("ALL_SELECTED");

export const change_search_form = actionCreator("CHANGE_SEARCH_FORM");

export const check_completed = actionCreator("CHECK_COMPLETED");
export const change_search_loading = actionCreator<boolean>("CHANGE_SEARCH_LOADING");

export const check_completed_cancel = actionCreator("CHECK_COMPLETED_CANCEL");


export const owner_tel_checked = actionCreator("OWNER_TEL_CHECKED");
export const change_owner_tel_check_loading = actionCreator<number>("CHANGE_OWNER_TEL_CHECK_LOADING");


export const change_kyoukyuu_titen_list = actionCreator<number>("CHANGE_KYOUKYUU_TITEN_LIST");


export const contract_check_download_pint_csv = actionCreator<number>("CONTRACT_CHECK_PINT_DOWNLOAD_CSV");


export const change_rent_contract_logs = actionCreator<any>("CHANGE_RENT_CONTRACT_LOGS");

export const get_rent_contract_logs = actionCreator<number>("GET_RENT_CONTRACT_LOGS");

export const check_rent_contract_logs = actionCreator<number>("CHECK_RENT_CONTRACT_LOGS");


// export const change_search_name = actionCreator<string>("CHANGE_SEARCH_NAME");
// export const change_search_contract_date_start = actionCreator<string>("CHANGE_SEARCH_CONTRACT_DATE_START");
// export const change_search_contract_date_end = actionCreator<string>("CHANGE_SEARCH_CONTRACT_DATE_END");


// export const bind_kyousai_contract = actionCreator('BIND_KYOUSAI_CONTRACT');

// export const change_search_tatemono_name = actionCreator<string>("CHANGE_SEARCH_TATEMONO_NAME");




// export const get_banks_failure = actionCreator("GET_BANKS_FAILURE");

// export const getUsers = actionCreator('USERS_REQUEST');
// export const getUsersSuccess = actionCreator("USERS_SUCCESS");
// export const getUsersFailure = actionCreator("USERS_FAILURE");

// export const getRentAgents = actionCreator('RENT_AGENTS_REQUEST');
// export const getRentAgentsSuccess = actionCreator("RENT_AGENTS_SUCCESS");
// export const getRentAgentsFailure = actionCreator("RENT_AGENTS_FAILURE");


// export const getRentMReasons = actionCreator('RENT_M_REASONS_REQUEST');
// export const getRentMReasonsSuccess = actionCreator("RENT_M_REASONS_SUCCESS");
// export const getRentMReasonsFailure = actionCreator("RENT_M_REASONS_FAILURE");


export const contractcheckReducer = reducerWithInitialState(initialState)
    .case(change_rent_contracts_check_list, (state, payload) => ({ ...state, rent_contracts_check_list: payload }))
    .case(change_parking_check_loading, (state, payload) => ({ ...state, parking_check_loading: payload }))

    .case(change_net_check_loading, (state, payload) => ({ ...state, net_check_loading: payload }))
    .case(change_energization_check_loading, (state, payload) => ({ ...state, energization_check_loading: payload }))
    .case(change_wifi_check_loading, (state, payload) => ({ ...state, wifi_check_loading: payload }))
    .case(change_autolock_check_loading, (state, payload) => ({ ...state, autolock_check_loading: payload }))
    .case(change_electronics_check_loading, (state, payload) => ({ ...state, electronics_check_loading: payload }))
    .case(change_search_form, (state, payload) => ({ ...state, search_form: payload }))
    .case(change_search_loading, (state, payload) => ({ ...state, search_loading: payload }))

    .case(change_owner_tel_check_loading, (state, payload) => ({ ...state, owner_tel_check_loading: payload }))

    .case(change_kyoukyuu_titen_list, (state, payload) => ({ ...state, kyoukyuu_titen_list: payload }))

    .case(change_rent_contract_logs, (state, payload) => ({ ...state, rent_contract_logs: payload }))



// .case(change_search_contract_date_start, (state, payload) => ({ ...state, search_contract_date_start: payload }))
// .case(change_search_contract_date_end, (state, payload) => ({ ...state, search_contract_date_end: payload }))
// .case(change_search_tatemono_name, (state, payload) => ({ ...state, search_tatemono_name: payload }))



//.case(getRentMMedeasFailure, (state, payload) => ({ ...state, rentMMedeas: payload }))
// .case(getUsersSuccess, (state, payload) => ({ ...state, users: payload }))
// .case(getUsersFailure, (state, payload) => ({ ...state, users: payload }))
// .case(getRentAgentsSuccess, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentAgentsFailure, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentMReasonsSuccess, (state, payload) => ({ ...state, rentMReasons: payload }))
// .case(getRentMReasonsFailure, (state, payload) => ({ ...state, rentMReasons: payload }));







// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const contractcheckSaga = [
    //     takeEvery('GET_RENT_CONTRACT_MONIES', handleRequestMoney),
    // takeEvery('GET_RENT_CONTRACT_ACCOUNTING', handle_get_rent_contract_accounting),
    takeEvery('GET_RENT_CONTRACTS_CHECK_LIST', handle_get_rent_contracts_check_list),
    takeEvery('PARKING_CHECKED', handle_parking_checked),

    takeEvery('NET_CHECKED', handle_net_checked),

    takeEvery('ENERGIZATION_CHECKED', handle_energization_checked),

    takeEvery('ELECTRONICS_CHECKED', handle_electronics_checked),
    takeEvery('WIFI_CHECKED', handle_wifi_checked),
    takeEvery('AUTOLOCK_CHECKED', handle_autolock_checked),
    // takeEvery('BIND_KYOUSAI_CONTRACT', handle_bind_kyousai_contract),

    takeEvery('COMPLETED_CHECKED', handle_completed_checked),

    takeEvery('ALL_SELECTED', handle_all_selected),

    takeEvery('CHECK_COMPLETED', handle_check_completed),

    takeEvery('CHECK_COMPLETED_CANCEL', handle_check_completed_cancel),

    takeEvery('OWNER_TEL_CHECKED', handle_owner_tel_checked),


    takeEvery('CONTRACT_CHECK_PINT_DOWNLOAD_CSV', handle_contract_check_download_pint_csv),

    takeEvery('GET_RENT_CONTRACT_LOGS', handle_get_rent_contract_logs),

    takeEvery('CHECK_RENT_CONTRACT_LOGS', handle_check_rent_contract_logs),



    // takeEvery('USERS_REQUEST', handleUsersRequest),
    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;



function* handle_get_rent_contracts_check_list(action: any) {
    const state = yield select();

    let search_form = state.ContractCheck.search_form
    yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(rent_contracts_check_api.list, search_form);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し
        console.log(payload)
        let payloads = payload.map(function (value: any) {
            // value.office_check_completed = value.office_check_completed_at ? true : false
            value.room_name = value.room_name + (value.room_name2 ? "," + value.room_name2 : "") + (value.room_name3 ? "," + value.room_name3 : "")


            value.office_check_completed = false
            return value
        })
        // alert()
        yield put(change_rent_contracts_check_list(payloads));


        let kyoukyuu_titen_list: any = []
        payload.map(function (value: any) {
            // value.office_check_completed = value.office_check_completed_at ? true : false

            if (value.kyoukyuu_titen_no) {
                if (value.energization && !value.office_check_energization_at) {
                    kyoukyuu_titen_list.push({
                        kyoukyuu_titen_no: '=\"' + String(value.kyoukyuu_titen_no) + '\"',
                        shubetsu: '廃止',
                        contract_date: moment(value.contract_date).format("YYYY/MM/DD"),
                        reason: '需要者申出',
                        kaitai_date: '',
                        kaitai_time: '',
                        tatiai_date: '',
                        tatiai_time: '',
                        tatemono: value.building_name + value.room_name,

                    })
                }
            }

        })
        yield put(change_kyoukyuu_titen_list(kyoukyuu_titen_list));





        yield put(change_search_loading(false))

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}




function* handle_get_rent_contract_logs(action: any): any {
    const state = yield select();

    yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(rent_contracts_check_api.changelist, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し
        console.log(payload)
        // alert(payload.length)
        // alert()
        yield put(change_rent_contract_logs(payload));


        yield put(change_search_loading(false))

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}



function* handle_check_rent_contract_logs(action: any): any {
    const state = yield select();
    yield put(change_rent_contracts_check_list([]))
    yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    const { payload, error } = yield call(rent_contracts_check_api.check_changelist, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し
        console.log(payload)
        // alert(payload.length)
        // alert()
        let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
        let s = rent_contracts_check_list.map(function (value: any) {
            if (value.id === action.payload) {
                value.change_send_pm_flg = 0
                value.change_confirm_pm_at = payload.change_confirm_pm_at
                value.change_confirm_pm_user_id = payload.change_confirm_pm_user_id
                value.change_confirm_pm_user_name = payload.change_confirm_pm_user_name
            }
            return value

        })


        yield put(change_rent_contracts_check_list(JSON.parse(JSON.stringify(s))));



        yield put(change_search_loading(false))

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}


function* handle_parking_checked(action: any) {
    const state = yield select();

    yield put(change_parking_check_loading(action.payload));
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        return { ...value, value }
    })
    yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.parking, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        let w = rent_contracts_check_list.map(function (value: any) {

            if (value.id === action.payload) {
                value.office_check_parking_user_name = payload.office_check_parking_user_name
                value.office_check_parking_at = payload.office_check_parking_at
                value.office_check_parking_user_name = payload.office_check_parking_user_name
                return {
                    ...value, value
                }
            } else {
                return value
            }
        })
        yield put(change_parking_check_loading(0));
        yield put(change_rent_contracts_check_list(w));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}


function* handle_net_checked(action: any) {
    const state = yield select();

    yield put(change_net_check_loading(action.payload));
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        return { ...value, value }
    })
    yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.net, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        let w = rent_contracts_check_list.map(function (value: any) {

            if (value.id === action.payload) {
                value.office_check_net_user_name = payload.office_check_net_user_name
                value.office_check_net_at = payload.office_check_net_at
                value.office_check_net_user_name = payload.office_check_net_user_name
                return {
                    ...value, value
                }
            } else {
                return value
            }
        })
        yield put(change_net_check_loading(0));
        yield put(change_rent_contracts_check_list(w));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}


function* handle_energization_checked(action: any) {
    const state = yield select();

    yield put(change_energization_check_loading(action.payload));
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        return { ...value, value }
    })
    yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.energization, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        let w = rent_contracts_check_list.map(function (value: any) {

            if (value.id === action.payload) {
                value.office_check_energization_user_name = payload.office_check_energization_user_name
                value.office_check_energization_at = payload.office_check_energization_at
                value.office_check_energization_user_name = payload.office_check_energization_user_name
                return {
                    ...value, value
                }
            } else {
                return value
            }
        })
        yield put(change_energization_check_loading(0));
        yield put(change_rent_contracts_check_list(w));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}


function* handle_electronics_checked(action: any) {
    const state = yield select();

    yield put(change_electronics_check_loading(action.payload));
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        return { ...value, value }
    })
    yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.electronics, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        let w = rent_contracts_check_list.map(function (value: any) {

            if (value.id === action.payload) {
                value.office_check_electronics_user_name = payload.office_check_electronics_user_name
                value.office_check_electronics_at = payload.office_check_electronics_at
                value.office_check_electronics_user_name = payload.office_check_electronics_user_name
                return {
                    ...value, value
                }
            } else {
                return value
            }
        })
        yield put(change_electronics_check_loading(0));
        yield put(change_rent_contracts_check_list(w));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}


function* handle_wifi_checked(action: any) {
    const state = yield select();

    yield put(change_wifi_check_loading(action.payload));
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        return { ...value, value }
    })
    yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.wifi, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        let w = rent_contracts_check_list.map(function (value: any) {

            if (value.id === action.payload) {
                value.office_check_wifi_user_name = payload.office_check_wifi_user_name
                value.office_check_wifi_at = payload.office_check_wifi_at
                value.office_check_wifi_user_name = payload.office_check_wifi_user_name
                return {
                    ...value, value
                }
            } else {
                return value
            }
        })
        yield put(change_wifi_check_loading(0));
        yield put(change_rent_contracts_check_list(w));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}

function* handle_autolock_checked(action: any) {
    const state = yield select();

    yield put(change_autolock_check_loading(action.payload));
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        return { ...value, value }
    })
    yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.autolock, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        let w = rent_contracts_check_list.map(function (value: any) {

            if (value.id === action.payload) {
                value.office_check_autolock_user_name = payload.office_check_autolock_user_name
                value.office_check_autolock_at = payload.office_check_autolock_at
                return {
                    ...value, value
                }
            } else {
                return value
            }
        })
        yield put(change_autolock_check_loading(0));
        yield put(change_rent_contracts_check_list(w));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}

function* handle_owner_tel_checked(action: any) {
    const state = yield select();

    yield put(change_owner_tel_check_loading(action.payload));
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        return { ...value, value }
    })
    yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.owner_tel, { rent_contract_id: action.payload });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        let w = rent_contracts_check_list.map(function (value: any) {

            if (value.id === action.payload) {
                value.office_check_owner_tel_user_name = payload.office_check_owner_tel_user_name
                value.office_check_owner_tel_at = payload.office_check_owner_tel_at
                value.office_check_owner_tel_user_name = payload.office_check_owner_tel_user_name
                return {
                    ...value, value
                }
            } else {
                return value
            }
        })
        yield put(change_owner_tel_check_loading(0));
        yield put(change_rent_contracts_check_list(w));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}



function* handle_completed_checked(action: any) {
    const state = yield select();


    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {
        if (value.id === action.payload) {
            value.office_check_completed = !value.office_check_completed
            return { ...value, value }
        } else {
            return value
        }
    })
    yield put(change_rent_contracts_check_list(s));



}


function* handle_all_selected(action: any) {
    const state = yield select();


    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
    let s = rent_contracts_check_list.map(function (value: any) {

        value.office_check_completed = action.payload
        return { ...value, value }

    })
    yield put(change_rent_contracts_check_list(s));



}



function* handle_check_completed(action: any) {
    const state = yield select();

    yield put(change_search_loading(true))
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list.filter((a: any) => a.office_check_completed === true)
    // let s = rent_contracts_check_list.map(function (value: any) {
    //     return { ...value, value }
    // })
    // yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.check_completed, rent_contracts_check_list);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し


        yield put(get_rent_contracts_check_list(payload));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}


function* handle_check_completed_cancel(action: any) {
    const state = yield select();

    yield put(change_search_loading(true))
    let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list.filter((a: any) => a.office_check_completed === true)
    // let s = rent_contracts_check_list.map(function (value: any) {
    //     return { ...value, value }
    // })
    // yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.check_completed_cancel, rent_contracts_check_list);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し


        yield put(get_rent_contracts_check_list(payload));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}




function* handle_contract_check_download_pint_csv(action: any) {
    const state = yield select();

    // yield put(change_search_loading(true))
    // let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list.filter((a: any) => a.office_check_completed === true)
    // let s = rent_contracts_check_list.map(function (value: any) {
    //     return { ...value, value }
    // })
    // yield put(change_rent_contracts_check_list(s));

    const { payload, error } = yield call(rent_contracts_check_api.download_pint, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し

        console.log(payload)
        const a = document.createElement('a');
        // ダウンロードされるファイル名
        a.download = "PINT通電廃止リスト.csv";
        a.href = URL.createObjectURL(payload);
        // ダウンロード開始
        a.click();
        // yield put(get_rent_contracts_check_list(payload));


    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}
